export const ExcludeInitResourceEnum = [
  '/',
  '/products',
];
